import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
// plugins
import session from './plugins/session'
import http from './plugins/http'
// Telas Fixas
import Sistema from './views/Sistema'
import Login from './views/Login'
import LoginExterno from './views/LoginExterno'
import EscolhaAmbientes from './views/EscolhaAmbientes'
import NotFound from './views/NotFound'
import MinhasVendas from './views/MinhasVendas'
import Painel from './views/painel/Painel'
import LogoutSuccess from './views/LogoutSuccess'
import CookiesTerms from '@/views/CookiesTerms'
import TrocaAmbiente from '@/views/TrocaAmbiente'
import LoginExternoApi from '@/views/LoginExternoApi'
import SetarAmbienteSSOV2 from '@/views/SetarAmbienteSSOV2'
import LoginExternoEscritorio from '@/views/LoginExternoEscritorio'
import LoginExternoEscritoriov2 from '@/views/LoginExternoEscritoriov2'
import AutenticaUsuario from '@/views/cadastro-externo/AutenticaUsuario'
import CadastroUsuarioExterno from '@/views/cadastro-externo/CadastroUsuarioExterno'
import LoginPagamento from '@/views/pagamento/LoginPagamento'
import PainelLogin from '@/views/painel/Login'
import PagamentoCliente from '@/views/pagamento/PagamentoCliente'
import Cadastro from '@/views/cadastro/Cadastro'
import TabelaPoliticaVendas from '@/views/politica-vendas/TabelaPoliticaVendas'
import Reservas from '@/views/Reservas'
import LogoutUsuarioDesabilitado from './views/LogoutUsuarioDesabilitado.vue'

Vue.use(Router)

// noinspection JSUnusedGlobalSymbols
const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { title: 'Login ED - Vendas', public: true }
    },
    {
      path: '/login_externo',
      name: 'login_externo',
      component: LoginExterno,
      meta: { title: 'Login', public: true }
    },
    {
      path: '/escolher_ambiente',
      name: 'escolher_ambiente',
      component: EscolhaAmbientes,
      meta: { title: 'Escolha de Ambiente', public: true }
    },
    {
      path: '/troca_ambiente',
      name: 'troca_ambiente',
      component: TrocaAmbiente,
      meta: { title: 'Troca de Ambiente', public: true },
      beforeEnter (to, from, next) {
        if (from.name === 'minhas-vendas' || from.name === null) {
          next()
        } else {
          next({ name: 'minhas-vendas' })
        }
      }
    },
    {
      path: '/setar_ambiente_ssov2',
      name: 'setar_ambiente_ssov2',
      component: SetarAmbienteSSOV2,
      meta: { title: 'Escolha de Ambiente', public: true }
    },
    {
      path: '/cookies',
      name: 'Termos de Cookies',
      component: CookiesTerms,
      meta: { title: 'Termos de Cookies', public: true }
    },
    {
      path: '/login_externo_api',
      name: 'login_externo_api',
      component: LoginExternoApi,
      meta: { title: 'Login', public: true }
    },
    {
      path: '/autentica_usuario_externo',
      name: 'autentica_usuario_externo',
      component: AutenticaUsuario,
      meta: { title: 'Autentica Usuario', public: true }
    },
    {
      path: '/cadastro_usuario_externo',
      name: 'cadastro_usuario_externo',
      component: CadastroUsuarioExterno,
      meta: { title: 'Cadastro de Usuario Externo', public: true },
      beforeEnter (to, from, next) {
        if (from.name === 'autentica_usuario_externo') {
          next()
        } else {
          next({ name: 'autentica_usuario_externo', params: { 'vem_do_cadastro': true } })
        }
      }
    },
    {
      path: '/login_escritorio',
      name: 'login_escritorio',
      component: LoginExternoEscritorio,
      meta: { title: 'Login', public: true }
    },
    {
      path: '/login_escritorio_v2',
      name: 'login_escritorio_v2',
      component: LoginExternoEscritoriov2,
      meta: { title: 'Login', public: true }
    },
    {
      path: '/cliente/login/:flavor?',
      name: 'cliente-login',
      component: LoginPagamento,
      meta: { title: 'Link de Pagamento', public: true }
    },
    {
      path: '/cliente/pagamento',
      name: 'cliente-pagamento',
      component: PagamentoCliente,
      meta: { title: 'Pagamento', public: true },
      beforeEnter: (to, from, next) => {
        if (!to.params.id_pedido) {
          next({ name: 'cliente-login' })
        } else {
          next()
        }
      }
    },
    {
      path: '/painel/login',
      name: 'painel-login',
      component: PainelLogin,
      meta: { title: 'Painel Administrativo', public: true }
    },
    {
      path: '/logout',
      name: 'logout',
      meta: { title: 'Sair' },
      beforeEnter: (to, from, next) => {
        if (session.get('permite_logar_tela_login')) {
          session.destroy()
          next({ name: 'login' })
        } else {
          session.destroy()
          next({ name: 'logout-success' })
        }
      }
    },
    {
      path: '/logout-success',
      name: 'logout-success',
      component: LogoutSuccess,
      meta: { title: 'Logout com Sucesso', public: true }
    },
    {
      path: '/acesso-bloqueado',
      name: 'acesso-bloqueado',
      component: LogoutUsuarioDesabilitado,
      meta: { title: 'Acesso Bloqueado', public: true }
    },
    {
      path: '/painel',
      component: Painel,
      redirect: '/painel/bem-vindo',
      children: [
        {
          path: 'sincronizacao',
          name: 'painel-sincronizacao',
          component: () => import('@/views/painel/Sincronizacao'),
          meta: { title: 'Carga de informações' }
        },
        {
          path: 'bem-vindo',
          name: 'bemvindo-painel',
          component: () => import('./views/SemPermissoes'),
          meta: { title: 'Bem vindo ao painel!' }
        },
        {
          path: 'grupos-financiamento',
          name: 'grupos-financiamento',
          component: () => import('@/views/painel/config-grupos/ConfigGrupos'),
          meta: { title: 'Config. de Grupos' }
        },
        {
          path: 'grupo-vendas',
          name: 'grupo-vendas',
          component: () => import('@/views/painel/restricoes-venda/RestricoesVendaAba'),
          meta: { title: 'Restrições de Venda' }
        },
        {
          path: 'usuarios-config',
          name: 'usuarios-config',
          component: () => import('./views/painel/UsuarioConfig'),
          meta: { title: 'Usuários' }

        },
        {
          path: '/painel/configuracao-pagamento',
          name: 'configuracao-pagamento',
          component: () => import('@/views/painel/parametros-sistema/ParametrosSistema'),
          meta: { title: 'PARÂMETROS DO SISTEMA' }
        },
        {
          path: '/painel/cadastro/unidade-negocio',
          name: 'cadastro-unidade-negocio',
          component: () => import('@/views/painel/cadastros/UnidadesNegocio'),
          meta: { title: 'Un. Negócio' }
        },
        {
          path: '/painel/cadastro/tipo-cota',
          name: 'cadastro-tipo-cota',
          component: () => import('@/views/painel/cadastros/TiposCotas'),
          meta: { title: 'Tipos de Cotas' }
        },
        {
          path: '/painel/cadastro/produtos',
          name: 'cadastro-produtos',
          component: () => import('@/views/painel/cadastros/Produtos'),
          meta: { title: 'Produtos' }
        },
        {
          path: '/painel/regra-furo',
          name: 'regra-furo',
          component: () => import('@/views/painel/RegraFuro'),
          meta: { title: 'Regra de furo' }
        },
        {
          path: '/painel/log-sincronizacao',
          name: 'log-sincronizacao',
          component: () => import('@/views/painel/SincronizacaoManual'),
          meta: { title: 'Sincronização Manual' }
        },
        {
          path: '/painel/gerenciamento-terceiros',
          name: 'gerenciamento-terceiros',
          component: () => import('@/views/painel/GerenciamentoTerceiros'),
          meta: { title: 'Sistema de Terceiros' }
        },
        {
          path: '/painel/importa-proposta',
          name: 'importa-proposta',
          component: () => import('@/views/painel/ImportaProposta'),
          meta: { title: 'Importação de propostas CSV' }
        },
        {
          path: '/painel/importa-politica-vendas',
          name: 'importa-politica',
          component: () => import('@/views/painel/ImportaPoliticaVendas'),
          meta: { title: 'Importação Política Vendas' }
        },
        {
          path: '/painel/contratos',
          name: 'contratos',
          component: () => import('@/views/painel/contratos/Contratos'),
          meta: { title: 'Contratos' }
        },
        {
          path: '/painel/relatorios',
          name: 'relatorios',
          component: () => import('@/views/painel/Relatorios'),
          meta: { title: 'Relatórios' }
        },
        {
          path: '/painel/relatorios-vendas',
          name: 'relatorios-vendas',
          component: () => import('@/views/painel/RelatoriosVendas'),
          meta: { title: 'Relatório de Venda' }
        },
        {
          path: '/painel/relatorios-politica-vendas',
          name: 'relatorios-politica-vendas',
          component: () => import('@/views/painel/RelatoriosPoliticaVendas'),
          meta: { title: 'Relatório Política de Vendas' }
        },
        {
          path: '/painel/relatorios-erros',
          name: 'relatorios-erros',
          component: () => import('@/views/painel/RelatoriosErros'),
          meta: { title: 'Relatório de erro' }
        },
        {
          path: '/painel/relatorios-expurgos-propostas',
          name: 'relatorios-expurgos-propostas',
          component: () => import('@/views/painel/RelatoriosExpurgoPropostas'),
          meta: { title: 'Relatório de Rascunhos Expurgados' }
        },
        {
          path: '/painel/relatorios-expurgos-logs',
          name: 'relatorios-expurgos-logs',
          component: () => import('@/views/painel/RelatoriosExpurgoLogs'),
          meta: { title: 'Relatório de Logs Expurgados' }
        },
        {
          path: '/painel/auditoria',
          name: 'auditoria',
          component: () => import('@/views/painel/Auditoria'),
          meta: { title: 'Auditoria' }
        },
        {
          path: '/painel/flavor-config',
          name: 'flavor-config',
          component: () => import('./views/painel/FlavorConfig'),
          meta: { title: 'Ambientes' }
        },
        {
          path: '/painel/linkplataforma-rodobens',
          name: 'linkplataforma-rodobens',
          component: () => import('./views/painel/FlavorConfig'),
          meta: { title: 'Plataforma de Venda' }
        },
        {
          path: '/painel/configuracoes/analise-credito',
          name: 'config-analise-credito',
          component: () => import('./views/painel/credit-analysis/ConfigCreditAnalysisAba'),
          meta: { title: 'Configurações' }
        },
        {
          path: '/painel/configuracoes/relatorio-consultas',
          name: 'analise-credito-relatorio-consultas',
          component: () => import('./views/painel/credit-analysis/ConsultationReports'),
          meta: { title: 'Relatório de consultas' }
        },
        {
          path: '/painel/configuracoes/carrinho',
          name: 'configuracoes-carrinho',
          component: () => import('./views/painel/carrinho-compras/ConfiguracoesCarrinho'),
          meta: { title: 'Configurações' }
        },
        {
          path: '/painel/configuracoes/broker',
          name: 'broker',
          component: () => import('./views/painel/broker/ConfiguracoesBroker'),
          meta: { title: 'Configurações' }
        },
        {
          path: 'logout',
          name: 'painel-logout',
          meta: { title: 'Sair', public: true },
          beforeEnter: (to, from, next) => {
            session.destroy()
            next({ name: 'painel-login' })
          }
        }
      ]
    },
    {
      path: '/',
      component: Sistema,
      children: [
        {
          path: '/',
          redirect: '/minhas-vendas'
        },
        {
          path: '/bem-vindo',
          name: 'bem-vindo',
          component: () => import('./views/BemVindo'),
          meta: { title: 'Bem-vindo' }
        },
        {
          path: '/cadastro',
          name: 'cadastro',
          component: Cadastro,
          meta: { title: 'Iniciar Cadastro' },
          beforeEnter: beforeLeaveFluxoVendas
        },
        {
          path: '/iniciar-venda',
          name: 'iniciar-venda',
          component: Cadastro,
          meta: { title: 'Iniciar Venda' },
          beforeEnter: beforeLeaveFluxoVendas
        },
        {
          path: '/politica-vendas',
          name: 'politica-vendas',
          component: TabelaPoliticaVendas,
          meta: { title: 'Política de Vendas' },
          beforeEnter: beforeLeaveFluxoVendas
        },
        {
          path: '/politica-vendas/selecionar-bem',
          name: 'selecionar-bem-politica-vendas',
          component: () => import('@/views/politica-vendas/SelecionarBemPoliticaVendas'),
          meta: { title: 'Selecionar Bem' },
          beforeEnter: beforeLeaveFluxoVendas
        },
        {
          path: '/minhas-vendas',
          name: 'minhas-vendas',
          component: MinhasVendas,
          meta: { title: 'Minhas Vendas' }
        },
        {
          path: '/reservas',
          name: 'reservas',
          component: Reservas,
          meta: { title: 'Reservas' }
        },
        {
          path: '/minhas-vendas/detalhes-venda',
          name: 'detalhes-venda',
          component: () => import('@/views/DetalhesVenda'),
          meta: { title: 'Detalhes da venda' }
        },
        {
          path: '/minhas-vendas/detalhes-carrinho/:id_pedido',
          name: 'detalhes-carrinho',
          component: () => import('@/views/DetalhesVendaMultipla.vue'),
          meta: { title: 'Detalhes do Carrinho' }
        },
        {
          path: '/minhas-vendas/detalhes-venda/contrato-venda',
          name: 'contrato-venda',
          component: () => import('@/views/ContratoVenda'),
          meta: { title: 'Contrato' }
        },
        {
          path: '/*',
          name: 'nao-encontrada',
          component: NotFound,
          meta: { title: 'Página não encontrada' }
        }
      ]
    }
  ]
})

function beforeLeaveFluxoVendas (to, from, next) {
  if (!from.name) {
    next({ path: '/minhas-vendas' })
  }
  next()
}

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || ''
  checkSession(to, next)
  verifyDisponibility()
  verifyDeployStatus()
})

async function verifyDisponibility () {
  const { data } = await http.get('disponibilidade')
  store.commit('setDisponibility', data.disponivel)
}

async function verifyDeployStatus () {
  try {
    const { data } = await http.get('/verifica-deploy')
    store.commit('setDeployStatus', data.em_deploy)
  } catch (e) {
    console.error('[deploy check] erro:', e)
  }
}

function checkSession (to, next) {
  if (session.get('perfil_adm') > 1 && typeof session.get('funcionalidades_permitidas') !== 'undefined' && session.get('funcionalidades_permitidas').length > 0 && to.path.includes('painel') && !to.path.includes('login') && !to.path.includes('logout')) {
    const permissao = getPermissionsUser(to)
    if (permissao !== true) {
      next({ path: permissao[0].path })
      to.name = permissao[0].name
    }
  }
  if (!session.get('exibe_politica_vendas') && to.name === 'politica-vendas') {
    next({ path: '/minhas-vendas' })
    to.name = '/minhas-vendas'
  }
  if (!session.get('exibe_contratos_painel') && to.name === 'contratos') {
    next({ path: '/painel/grupos-financiamento' })
    to.name = 'grupos-financiamento'
  }

  const query = to.query

  if (typeof query.origem_painel !== 'undefined' && query.origem_painel) {
    session.destroy()

    session.set('_l', query.login)
    session.set('_s', query.senha)
    session.set('sessao_painel', query.origem_painel)

    next({ name: 'login', params: query })
    next()
  }

  if (session.exists()) {
    if (to.name === 'login') {
      next({ path: '/' })
    } else {
      next()
    }
  } else if (!to.meta.public) {
    next({ name: 'login' })
  } else {
    next()
  }
}

function getPermissionsUser (to) {
  const funcionalidades = [
    {
      path: 'sincronizacao',
      name: 'painel-sincronizacao',
      id_funcionalidade: 1,
      meta: { title: 'Carga de informações' }
    },
    {
      path: 'bem-vindo',
      name: 'bemvindo-painel',
      component: () => import('./views/BemVindo'),
      meta: { title: 'Bem vindo ao painel!' },
      id_funcionalidade: null
    },
    {
      path: 'grupos-financiamento',
      name: 'grupos-financiamento',
      id_funcionalidade: 7,
      meta: { title: 'Config. de Grupos' }
    },
    {
      path: 'grupo-vendas',
      name: 'grupo-vendas',
      id_funcionalidade: 8,
      meta: { title: 'Restrições de Venda' }
    },
    {
      path: 'usuarios-config',
      name: 'usuarios-config',
      id_funcionalidade: 14,
      meta: { title: 'Usuários' }
    },
    {
      path: '/painel/configuracao-pagamento',
      name: 'configuracao-pagamento',
      id_funcionalidade: 9,
      meta: { title: 'PARÂMETROS DO SISTEMA' }
    },
    {
      path: '/painel/regra-furo',
      name: 'regra-furo',
      id_funcionalidade: 6,
      meta: { title: 'Regra de furo' }
    },
    {
      path: '/painel/log-sincronizacao',
      name: 'log-sincronizacao',
      id_funcionalidade: 3,
      meta: { title: 'Sincronização Manual' }
    },
    {
      path: '/painel/gerenciamento-terceiros',
      name: 'gerenciamento-terceiros',
      id_funcionalidade: 13,
      meta: { title: 'Sistema de Terceiros' }
    },
    {
      path: '/painel/importa-proposta',
      name: 'importa-proposta',
      id_funcionalidade: 2,
      meta: { title: 'Importação de propostas CSV' }
    },
    {
      path: '/painel/importa-politica-vendas',
      name: 'importa-politica',
      id_funcionalidade: 5,
      meta: { title: 'Importação Política Vendas' }
    },
    {
      path: '/painel/contratos',
      name: 'contratos',
      id_funcionalidade: 4,
      meta: { title: 'Contratos' }
    },
    {
      path: '/painel/relatorios',
      name: 'relatorios',
      meta: { title: 'Relatórios' }
    },
    {
      name: 'relatorios-vendas',
      path: '/painel/relatorios-vendas',
      id_funcionalidade: 10,
      meta: { title: 'Relatório de Venda' }
    },
    {
      name: 'relatorios-politica-vendas',
      path: '/painel/relatorios-politica-vendas',
      id_funcionalidade: 23,
      meta: { title: 'Relatório Política de Vendas' }
    },

    {
      path: '/painel/relatorios-erros',
      name: 'relatorios-erros',
      id_funcionalidade: 11,
      meta: { title: 'Relatório de erro' }
    },
    {
      path: '/painel/relatorios-expurgos-propostas',
      name: 'relatorios-expurgos-propostas',
      id_funcionalidade: 22,
      meta: { title: 'Relatório de Rascunhos Expurgados' }
    },
    {
      path: '/painel/relatorios-expurgos-logs',
      name: 'relatorios-expurgos-logs',
      id_funcionalidade: 25,
      meta: { title: 'Relatório de Logs Expurgados' }
    },
    {
      path: '/painel/auditoria',
      name: 'auditoria',
      id_funcionalidade: 12,
      meta: { title: 'Auditoria' }
    },
    {
      path: '/painel/flavor-config',
      name: 'flavor-config',
      id_funcionalidade: 15,
      meta: { title: 'Ambientes' }
    },
    {
      path: '/painel/linkplataforma-rodobens',
      name: 'linkplataforma-rodobens',
      id_funcionalidade: 16,
      meta: { title: 'Plataforma de Venda' }
    },
    {
      path: '/painel/configuracoes/analise-credito',
      name: 'config-analise-credito',
      id_funcionalidade: 17,
      meta: { title: 'Configuração de consulta a Análise de Crédito' }
    },
    {
      path: '/painel/configuracoes/relatorio-consultas',
      name: 'analise-credito-relatorio-consultas',
      id_funcionalidade: 18,
      meta: { title: 'Relatório de consultas' }
    },
    {
      path: '/painel/cadastro/unidade-negocio',
      name: 'cadastro-unidade-negocio',
      id_funcionalidade: 19,
      meta: { title: 'Un. Negócio' }
    },
    {
      path: '/painel/cadastro/tipo-cota',
      name: 'cadastro-tipo-cota',
      id_funcionalidade: 20,
      meta: { title: 'Tipos de Cotas' }
    },
    {
      path: '/painel/cadastro/produtos',
      name: 'cadastro-produtos',
      id_funcionalidade: 24,
      meta: { title: 'Produtos' }
    },
    {
      path: '/painel/configuracoes/carrinho',
      name: 'configuracoes-carrinho',
      id_funcionalidade: 21,
      meta: { title: 'Configurações' }
    },
    {
      path: '/painel/configuracoes/broker',
      name: 'broker',
      id_funcionalidade: 27,
      meta: { title: 'Configurações' }
    }
  ]

  const funcionalidade_acessada = funcionalidades.filter(func => func.name === to.name)
  const primeira_funcionalidade = funcionalidades.filter(func => func.id_funcionalidade === session.get('funcionalidades_permitidas')[0])
  if (session.get('funcionalidades_permitidas').includes(funcionalidade_acessada[0].id_funcionalidade)) {
    return true
  } else {
    return primeira_funcionalidade
  }
}

export default router
